import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import About from '@/components/about'
import Customized from '@/components/customized'
import LeadingTechnology from '@/components/leadingTechnology'
import Mall from '@/components/mall'
import Pay from '@/components/mall/pay'
import Goods from '@/components/mall/goods'
import Solution from '@/components/solution'
import SolutionDetail from '@/components/solution/detail'
import SolutionDetail1 from '@/components/solution/detail1'
import SolutionDetail2 from '@/components/solution/detail2'
import SolutionDetail3 from '@/components/solution/detail3'
import SolutionDetail4 from '@/components/solution/detail4'
import SolutionDetail5 from '@/components/solution/detail5'
import SolutionDetail6 from '@/components/solution/detail6'
import SolutionDetail7 from '@/components/solution/detail7'
import SolutionDetail8 from '@/components/solution/detail8'
import SolutionDetail9 from '@/components/solution/detail9'
import SolutionDetail10 from '@/components/solution/detail10'
import UserEntry from '@/components/userEntry'
import UserLogin from '@/components/userEntry/login'
import UserRegister from '@/components/userEntry/register'
import Case from '@/components/case'
import CaseDetail from '@/components/case/detail'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/hzdz',
      name: 'Customized',
      component: Customized
    },
    {
      path: '/lxju',
      name: 'LeadingTechnology',
      component: LeadingTechnology
    },
    {
      path: '/case',
      name: 'case',
      component: Case
    },
    {
      path: '/case/detail',
      name: 'CaseDetail',
      component: CaseDetail
    },
    {
      path: '/mall',
      component: Mall,
      children: [
        {
          path: '',
          name: "Goods",
          component: Goods
        },
        {
          path: 'pay',
          name: 'Pay',
          component: Pay
        }
      ]
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution
    },
    {
      path: '/solution/detail',
      name: 'SolutionDetail',
      component: SolutionDetail,
      children: [
        {
          path: '1',
          component: SolutionDetail1
        },
        {
          path: '2',
          component: SolutionDetail2
        },
        {
          path: '3',
          component: SolutionDetail3
        },
        {
          path: '4',
          component: SolutionDetail4
        },
        {
          path: '5',
          component: SolutionDetail5
        },
        {
          path: '6',
          component: SolutionDetail6
        },
        {
          path: '7',
          component: SolutionDetail7
        },
        {
          path: '8',
          component: SolutionDetail8
        },
        {
          path: '9',
          component: SolutionDetail9
        },
        {
          path: '10',
          component: SolutionDetail10
        }
      ]
    },
    {
      path: '/entry',
      component: UserEntry,
      children: [
        {
          path: 'login',
          name: "Login",
          component: UserLogin
        },
        {
          path: 'register',
          name: 'Register',
          component: UserRegister
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js